import parseErrors from '@/lib/errors/parseErrors'
import toastErrors from '@/lib/errors/toastErrors'

export const vuexDefaultMapping = {
  actions: ['fetchOne'],
  getters: ['loading'],
  state: ['current', 'status'],
}

export default {
  data() {
    return { errors: [] }
  },

  methods: {
    addErrors(errors) {
      this.errors = errors
    },
  },

  async created() {
    const { id } = this.$route.params
    if (!this.current || this.current.id !== id) {
      try {
        await this.fetchOne(id)
      } catch (e) {
        this.addErrors(parseErrors(e))
        toastErrors(e)
      }
    }
  },
}
